import * as prismic from '@prismicio/client';

export const prismicClient = prismic.createClient(
  process.env.GATSBY_PRISMIC_REPOSITORY_NAME,
  {
    accessToken: process.env.GATSBY_PRISMIC_ACCESS_TOKEN,
    fetch,
  }
);
